module.exports = __webpack_public_path__ + "0c0d4bf16bc37bc8717edec79768f7f4.png";